import { z } from 'zod';

export const ACCOUNT_STATUSES = [
  'warming_up',
  'available',
  'cooldown',
  'disabled',
  'banned',
] as const;
export type AccountStatus = (typeof ACCOUNT_STATUSES)[number];

// Phase 10 — Plan 10-01 storage/sender split. `sender` accounts dispatch
// outbound trades; `storage` accounts hold the items the replenishment
// worker pulls from.
export const ACCOUNT_ROLES = ['storage', 'sender'] as const;
export type AccountRole = (typeof ACCOUNT_ROLES)[number];

export const AccountCreateSchema = z.object({
  steamLogin: z.string().trim().min(1, 'Введите логин'),
  steamId64: z.string().trim().regex(/^\d+$/, 'Steam ID64 должен состоять только из цифр'),
  password: z.string().min(1, 'Введите пароль'),
  sharedSecret: z.string().min(1, 'Введите shared secret'),
  identitySecret: z.string().min(1, 'Введите identity secret'),
  revocationCode: z.string().optional(),
  email: z.string().email().optional().or(z.literal('')),
  emailPassword: z.string().optional(),
  refreshToken: z.string().optional(),
});

export const AccountUpdateSchema = z.object({
  role: z.enum(ACCOUNT_ROLES).optional(),
  status: z.enum(ACCOUNT_STATUSES).optional(),
  maxActiveTrades: z.coerce.number().int().min(1).max(1000).optional(),
  email: z.string().email().optional().or(z.literal('')),
});

export type AccountCreateInput = z.infer<typeof AccountCreateSchema>;
export type AccountUpdateInput = z.infer<typeof AccountUpdateSchema>;
